import { useEffect, useState, type CSSProperties } from "react";
import { Toaster as Sonner, type ToasterProps } from "sonner";

// <html> の `dark` クラス（lib/theme.ts が切り替える）に追従してトーストの配色を合わせる
function useResolvedTheme(): "light" | "dark" {
  const read = (): "light" | "dark" => (document.documentElement.classList.contains("dark") ? "dark" : "light");
  const [theme, setTheme] = useState(read);
  useEffect(() => {
    const observer = new MutationObserver(() => setTheme(read()));
    observer.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);
  return theme;
}

export function Toaster(props: ToasterProps) {
  const theme = useResolvedTheme();
  return (
    <Sonner
      theme={theme}
      position="top-right"
      // AppHeader（h-14 = 56px）の右上メニューに被らないよう、ヘッダーの下に出す
      offset={{ top: 64, right: 16 }}
      mobileOffset={{ top: 64, right: 16 }}
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
          "--border-radius": "var(--radius)",
          zIndex: "var(--z-toast)",
        } as CSSProperties
      }
      {...props}
    />
  );
}
